import { FormControl } from '@angular/forms';

export enum DashboardViewOptions {
	LEADS = 'LEADS',
	SCHEDULE = 'SCHEDULE',
}

export interface IDashboardViewForm {
	view: FormControl<DashboardViewOptions>;
}

export interface IScheduleForm {
	view: FormControl<ScheduleViewOptions>;
}

export enum ScheduleViewOptions {
	TODAY = 'TODAY',
	WEEK = 'WEEK',
}
